<template>
  <div :class="$style['wt-checkbox']">
      <el-checkbox-group v-model="crrentValue" @change="change">
          <el-checkbox v-for="(item,index) in checkList" :key="index" :label="item[valueName]||item[labelName]||item">{{item[labelName]||item[valueName]||item}}</el-checkbox>
      </el-checkbox-group>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'wt-checkbox'

export default {
  name: 'wt-checkbox',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    checkList: {
      type: Array,
      default: function () {
        return []
      }
    },
    value: {
      type: [Array, String],
      default: function () {
        return []
      }
    },
    valueName: {
      type: String,
      default: 'value'
    },
    labelName: {
      type: String,
      default: 'label'
    }
  },
  data () {
    return {
      crrentValue: this.value || []
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.crrentValue = val
      }
    },
    crrentValue: {
      handler: function (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    change (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.wt-checkbox{
    :global
    .el-checkbox{
        &.el-checkbox{
            margin-left: 0
        }
    }
}
</style>
